import { StarterArticles, StarterArticleSource } from '../../../../types/StarterGuideTypes';

export const articles: StarterArticles = {
  title: 'Learn More',
  articles: [
    {
      title: 'New Puppy Tips: 8 Mistakes New Puppy Parents Make',
      image: '/wp-content/uploads/2020/03/28112206/new-puppy-tips-300x160.jpg',
      link: '/training-training-tips-8-mistakes-new-puppy-parents-make/',
      source: StarterArticleSource.BE_CHEWY,
    },
    {
      title: 'When Should You Start Heartworm Prevention for Puppies?',
      image:
        '/sites/default/files/styles/additional_slideshows_281_192/public/puppy-behing-gate.jpg',
      link:
        '/dog/conditions/infectious-parasitic/when-should-you-start-heartworm-prevention-puppies',
      source: StarterArticleSource.PET_MD,
    },
  ],
};
